// @flow
import React from 'react';
import PropTypes from 'prop-types';
// import {Box, ButtonGroup} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Hidden} from '@material-ui/core';

import type {Node} from 'react';

type Props = {|
  children?: Node,
  className?: string,
|};

const useStyles = makeStyles(theme => ({
  fieldsWrapScroll: {
    display: 'flex',
    flexWrap: 'nowrap',
    // width: '100%',
    // overflowY: 'hidden',
    // whiteSpace: 'nowrap',
    overflowX: 'auto',
    // width: '100%',
    // height: theme.spacing(4),
  },
  extraSpace: {
    width: theme.spacing(4),
    minWidth: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(2),
      minWidth: theme.spacing(2),
    },
  },
}));

export default function HorizontalScroll(props: Props) {
  const {children, className} = props;
  const classes = useStyles();
  return (
    <div className={`${classes.fieldsWrapScroll} ${className || ''}`}>
      <Hidden smUp>
        <div className={classes.extraSpace} />
      </Hidden>
      {children}
      <div className={classes.extraSpace} />
    </div>
  );
}

HorizontalScroll.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
